// extracted by mini-css-extract-plugin
var _1 = "ICODialog-module__closeButton--gEhoN";
var _2 = "ICODialog-module__icoDialog--h2y7q";
var _3 = "ICODialog-module__icoDialogBottomCloseButton--t04AU";
var _4 = "ICODialog-module__icoDialogContent--P6UX4";
export { _1 as "closeButton", _2 as "icoDialog", _3 as "icoDialogBottomCloseButton", _4 as "icoDialogContent" }
